import { render } from "./NewInfoCard.vue?vue&type=template&id=9d11cbfc&scoped=true"
import script from "./NewInfoCard.vue?vue&type=script&lang=js"
export * from "./NewInfoCard.vue?vue&type=script&lang=js"

import "./NewInfoCard.vue?vue&type=style&index=0&id=9d11cbfc&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d11cbfc"]])

export default __exports__